module.exports = __webpack_public_path__ + "img/slika69.f77119fa.jpg";